import ImplementationIcon from './component.jsx'
export default ImplementationIcon
